import { useState, useEffect } from "react";
import { saveHouseBankDetails } from "../Api/HouseBank";
import { fetchAllResources } from "../Api/ResourceMaster";
import { getAllGeneralLedgers } from "../Api/GLMaster";
import { getAllCompanyCodes } from "../Api/CompanyLocationMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
const HouseBank = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const {user}=useAuth();
  const [houseBankData, setHouseBankData] = useState({
    bankName: "",
    accountNumber: "",
    customerId: "",
    ifscCode: "",
    accountOpeningDate: "",

    companycode: "",
    resourceId: "",
    resourceIdDummy: "",
    glCode: "",
    organisationId:user?.organisationId
  });

  const [resources, setResources] = useState([]);
  const [generalLedgers, setGeneralLedgers] = useState([]);
  const [companyCodes, setCompanyCodes] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Load resources
        const res = await fetchAllResources(user?.organisationId);
        setResources(res || []);

        // Load general ledgers
        const glResponse = await getAllGeneralLedgers();
        setGeneralLedgers(glResponse || []);

        // Load company codes
        const ccResponse = await getAllCompanyCodes();
        console.log(ccResponse);
        setCompanyCodes(ccResponse || []);
      } catch (error) {
        toast.error("Failed to load data");
      }
    };
    loadData();
  }, []);

  const handleChange = (e) => {
    setHouseBankData({ ...houseBankData, [e.target.name]: e.target.value });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   setLoading(true);
  //   try {
  //     await saveHouseBankDetails(houseBankData, userId);
  //     toast.success("🦄 House Bank Added Successfully");
  //     setHouseBankData({
  //       bankName: "",
  //       accountNumber: "",
  //       customerId: "",
  //       ifscCode: "",
  //       accountOpeningDate: "",

  //       companycode: "",
  //       resourceId: "",
  //       resourceIdDummy: "",
  //       glCode: "",
  //     });
  //     navigate("/viewHouseBank");
  //   } catch (error) {
  //     toast.error(error.message || "🦄 Some Error Happened");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      console.log("Data being sent to API:", houseBankData); // 👈 Check the object
      console.log("User ID being sent:", userId); // 👈 Check the user ID

      await saveHouseBankDetails(houseBankData, userId);

      toast.success("🦄 House Bank Added Successfully");

      setHouseBankData({
        bankName: "",
        accountNumber: "",
        customerId: "",
        ifscCode: "",
        accountOpeningDate: "",
        companycode: "",
        resourceId: "",
        resourceIdDummy: "",
        glCode: "",
        organisationId:user?.organisationId
      });

      navigate("/viewHouseBank");
    } catch (error) {
      toast.error(error.message || "🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">House Bank Details</h2>
          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Bank Name <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="bankName"
                    value={houseBankData.bankName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Account Number <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="accountNumber"
                    value={houseBankData.accountNumber}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Customer ID <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="customerId"
                    value={houseBankData.customerId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    IFSC Code <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ifscCode"
                    value={houseBankData.ifscCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Account Opening Date <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="accountOpeningDate"
                    value={houseBankData.accountOpeningDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Company Code</Form.Label>
                  <Form.Select
                    name="companycode"
                    value={houseBankData.companycode}
                    onChange={handleChange}
                  >
                    <option value="">Select Company Code</option>
                    {companyCodes.map((cc) => (
                      <option key={cc.companyCode} value={cc.companyCode}>
                        {cc.companyCode} - {cc.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Resource ID</Form.Label>
                  <Form.Select
                    name="resourceId"
                    value={houseBankData.resourceId}
                    onChange={handleChange}
                  >
                    <option value="">Select Resource</option>
                    {resources.map((res) => (
                      <option key={res.value} value={res.value}>
                        {res.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Resource ID Dummy</Form.Label>

                  <Form.Select
                    name="resourceIdDummy"
                    value={houseBankData.resourceIdDummy}
                    onChange={handleChange}
                  >
                    <option value="">Select Resource</option>
                    {resources.map((res) => (
                      <option key={res.value} value={res.value}>
                        {res.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>GL Code</Form.Label>
                  <Form.Select
                    name="glCode"
                    value={houseBankData.glCode}
                    onChange={handleChange}
                  >
                    <option value="">Select GL Code</option>
                    {generalLedgers.map((gl) => (
                      <option key={gl.code} value={gl.code}>
                        {gl.glmasterId} - {gl.description || "N/A"}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button variant="primary" type="submit" className="fields-submit">
                Save Bank Details
              </Button>
            </div>
          </Form>
        </Container>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default HouseBank;
